import { storyblokEditable } from "@storyblok/react";
import React, { useEffect, useState } from "react";
import Script from "next/script";

const ContactPartner = ({ blok }) => {
  const [successBox, setSuccessBox] = useState("none");

  const createFormCP = () => {
    Formio.createForm(
      document.getElementById("contactpartnerForm"),
      "https://forms.erfolgreichgastro.de/#/form/63fcb1aa16056f5e5acb9910/",{
        hooks: {
          customValidation: async (submission, next) => {
              const submissionData = JSON.stringify(submission.data);

              if (submissionData.includes("<") || submissionData.includes(">")) {
                console.error('Fehler beim Validieren des Formulars auf dem Server.');
                alert('Folgende Zeichen sind nicht erlaubt: <, >');
              }else{
                next();
              }
          }
      }
    }
    ).then(function (form) {
      form.on("render", function () {
        const selectField = form.getComponent("chooseContactPartner");
        const selectFieldLabel = document.querySelector('.col-form-label');


        if (
          window.location ==
            "https://hpew.datenwerk.dev/schanktechnik/" ||
          window.location == "http://localhost:3000/schanktechnik/" ||   window.location ==
          "http://localhost:3000/bierpflege/" ||   window.location ==
          "https://hpew.datenwerk.dev/bierpflege/"
          ||   window.location ==
          "https://www.erfolgreichgastro.de/bierpflege/"
          ||
          window.location == "https://www.erfolgreichgastro.de/schanktechnik/"
        ) {
          selectFieldLabel.style.display = 'none';
          selectField.setValue("Schanktechnik & Bierpflege");
          selectField.disabled = true;
        } else {
          selectField.setValue("Vertrieb");
        }
        
        /* if (
          window.location ==
            "https://hpew.datenwerk.dev/hacker-pschorr/" ||
          window.location ==
            "http://localhost:3000/hacker-pschorr/"
            ||
          window.location ==
            "https://www.erfolgreichgastro.de/hacker-pschorr/"
        ) {
          selectField.setValue("Vertrieb Hacker-Pschorr");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/paulaner/" ||
          window.location == "http://localhost:3000/paulaner/"
          ||
          window.location == "https://www.erfolgreichgastro.de/paulaner/"
        ) {
          selectField.setValue("Vertrieb Paulaner");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/fuerstenberg/" ||
          window.location ==
            "http://localhost:3000/fuerstenberg/"
            ||
          window.location ==
            "https://www.erfolgreichgastro.de/fuerstenberg/"
        ) {
          selectField.setValue("Vertrieb Fürstenberg");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/auerbraeu/" ||
          window.location == "http://localhost:3000/auerbraeu/"
          ||
          window.location == "https://www.erfolgreichgastro.de/auerbraeu/"
        ) {
          selectField.setValue("Vertrieb Auerbräu");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/chiemseer/" ||
          window.location == "http://localhost:3000/chiemseer/"
          ||
          window.location == "https://www.erfolgreichgastro.de/chiemseer/"
        ) {
          selectField.setValue("Vertrieb Chiemseer");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/hopf/" ||
          window.location == "http://localhost:3000/hopf/"
          ||
          window.location == "https://www.erfolgreichgastro.de/hopf/"
        ) {
          selectField.setValue("Vertrieb Hopf");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/schmucker/" ||
          window.location == "http://localhost:3000/schmucker/"
          ||
          window.location == "https://www.erfolgreichgastro.de/schmucker/"
        ) {
          selectField.setValue("Vertrieb Schmucker");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/hoepfner/" ||
          window.location == "http://localhost:3000/hoepfner/"
          ||
          window.location == "https://www.erfolgreichgastro.de/hoepfner/"
        ) {
          selectField.setValue("Vertrieb Hoepfner");
        } else if (
          window.location ==
            "https://hpew.datenwerk.dev/schanktechnik/" ||
          window.location == "http://localhost:3000/schanktechnik/" ||   window.location ==
          "http://localhost:3000/bierpflege/" ||   window.location ==
          "https://hpew.datenwerk.dev/bierpflege/"
          ||   window.location ==
          "https://www.erfolgreichgastro.de/bierpflege/"
          ||
          window.location == "https://www.erfolgreichgastro.de/schanktechnik/"
        ) {
          selectFieldLabel.style.display = 'none';
          selectField.setValue("Schanktechnik & Bierpflege");
          selectField.disabled = true;
        } else {
          selectField.setValue("Vertrieb");
        } */
      });

      form.on("submit", function (submission) {
        showSuccessBox();
      });
    });
  };

  function showSuccessBox() {
    setSuccessBox("flex");
  }

  function newSubmit() {
    location.reload();
  }

  /*   useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.form.io/formiojs/formio.form.min.js";
    script.onload = createFormCP;
    document.body.appendChild(script);
  }, []); */
  useEffect(() => {
    createFormCP();
  }, []);

  return (
    <div className="wrap" style={{ background: `${blok.background}`}}>
      <div
        className="contact-partner-wrap flex inner-wrap"
        {...storyblokEditable(blok)}
        style={{ justifyContent: `${blok.centerContent}`}}
      >
        <div className="contact-img hide-desktop" style={{ display: `${blok.hideImage}` }}>
          <img src={blok.image.filename} alt={blok.image.alt} />
        </div>
        <div className="contact-content flex flex-col ml-8">
          <h2 className="text-2xl">{blok.subheadline}</h2>
          <img
            className="hide-mobile"
            src={blok.image.filename}
            alt={blok.image.alt}
            style={{ display: `${blok.hideImageMobile}` }}
          />

          {/*   <label for="brand" className="py-2">
        Wählen Sie eine Marke
      </label>
      <select name="brand" id="brand">
        <option value="brand1">Hacker-Pschor</option>
        <option value="brand2">Paulaner</option>
        <option value="brand3">Fürstenberg</option>
        <option value="brand4">Auerbräu</option>
        <option value="brand5">Chiemseer</option>
        <option value="brand6">Hopf</option>
        <option value="brand7">Schmucker</option>
        <option value="brand8">Hoepfner</option>
      </select>
      <span className="text-sm py-2">{blok.descriptioninput}</span>
      <div className="contact-input">
        <input type="text" />
        <button>{blok.button}</button>
      </div> */}
          <div className="contact-box">
            <div id="contactpartnerForm"></div>
            <div style={{ display: `${successBox}` }} className="success-box">
              <div>
                <p>Ihre Anfrage wurde erfolgreich an uns gesendet.</p>
                <p>Vielen Dank für Ihre Kontaktaufnahme.</p>

                <button onClick={newSubmit}>Weitere Anfrage stellen</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPartner;